import(/* webpackMode: "eager" */ "/app/landing/src/app/impressum/page.tsx");
